import ReactLoading from "react-loading";

export default function Loader({color}) {
  
  return (
    <div style={{marginTop:"50%"}} >
       <ReactLoading
        className="ldd"
        type="bubbles"
        color={`${color?color:"white"}`}
        height={"35%"}
        width={"35%"}
        /> 
    </div>
  );
}
